<template>
    <div id="bp-connections" class="container-fluid">
        <div class="container">
            <div class="row">
                <h5 class="copy-heading-sub"><b>{{ component.content.label }}</b></h5>
                <h2 class="copy-heading" v-html="component.content.title"></h2>
            </div>
            <div class="row" v-for="(tier, ind) in component.partners" :key="ind">
                <div :id="ind" class="col-12" v-if="ind == 'tier1'">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-6 col-lg-3 float-start partner-logo d-flex align-items-center justify-content-center text-center" v-for="( partner, index ) in tier" :key="index">
                                <a :href="partner.website" target="_blank">
                                    <img v-if="partner.logo" :src="partner.logo" class="img-fluid" />
                                    <h5 v-else ><b>{{ partner.company }}</b></h5>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row align-items-center justify-content-center">
                <router-link class="btn bp-btn" to="/connections" aria-label="Reviews">View More</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    // dependencies
    import shuffle from 'lodash/shuffle';

    // load assets
    import alchemyLogo from "../../assets/partners/alchemy.png"; 
    import cedarBarKitchenLogo from "../../assets/partners/CedarBar&Kitchen.png";
    import bellingenGolfLogo from "../../assets/partners/bellingenGolfclub.png";
    import theLodgeBellingenLogo from "../../assets/partners/theLodgeBellingen.png";

    export default( {
        name: "reviews-component",
        components: {
            
        },
        data() {
            return {
                component: {
                    content: {
                        label:      "Community",
                        title:      "Our Bellingen Connections",
                    },
                    partners: {
                        tier1: [
                            {
                                company: "Alchemy",
                                logo: alchemyLogo,
                                website: "https://www.alchemyinbellingen.com.au",
                                contact: [

                                ],
                            },
                            {
                                company: "The Lodge Bellingen",
                                logo: theLodgeBellingenLogo,
                                website: "https://thelodgebellingen.com.au",
                                contact: [

                                ],
                            }
                        ],
                    }
                }
            }
        },
        created() {
            const reviews = this.component.content.reviews;
            this.component.content.reviews = shuffle(reviews);
        }
    });
</script>

<style lang="scss" scoped >
    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    // component styles
    #bp-connections {
        background-color:$white;
        padding-bottom:6em;
        padding-top:6em;
        position:relative;
        .bp-btn {
            align-items:center;
            display:flex;
            justify-content:center;
            max-width:125px;
        }
    }
</style>